/* eslint-disable frontApplet/enforce-jsdoc */
import { EventEmitter } from 'events';
import IPostMessage from '../IPostMessage';
import ISerialPort from './ISerialPort';

export default class SerialPort implements ISerialPort {
	/** @internal */
	constructor(
		private refid: string,
		private eventEmitter: EventEmitter,
		private messagePrefix: string,
		private postMessage: IPostMessage<any>,
	) {}

	public onData(listener: (data: Uint8Array) => void) {
		this.eventEmitter.addListener('serial_port.data.' + this.refid, listener);
	}

	public async write(data: string | number[] | Uint8Array) {
		await this.postMessage({
			type: this.getMessage('serial_port.write'),
			refid: this.refid,
			data,
		});
	}

	public async close() {
		await this.postMessage({
			type: this.getMessage('serial_port.close'),
			refid: this.refid,
		});
		this.eventEmitter.removeAllListeners('serial_port.data.' + this.refid);
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + name;
	}
}
